import {MessageBar, MessageBarType, PrimaryButton} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AppContent from "../../Surfaces/AppContent";
import AuthContext from "../../Services/AuthContext";
import PaymentList from "../../Lists/PaymentList";

function MBankBank() {
    const [user] = useContext(AuthContext);
    const [file, setFile] = useState(null);
    const [result, setResult] = useState(null);
    const [payments, setPayments] = useState([]);
    const [refresh, setRefresh] = useState(0);


    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/payment/orphaned`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setPayments(data);})
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [refresh, user.token]);

    function _submitFile() {
        if (file !== null) {
            setResult('Importowanie...');
            const data = new FormData();
            data.append('file', file);
            fetch("/api/import/mbank", {
                method: 'post',
                body: data,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setResult(data); setRefresh(refresh + 1); })
                .catch(err => { console.log(err) })
        }
    }

    function messageBar(result) {
        if (result === null) {
            return '';
        }
        if (typeof result === 'string') {
            return <MessageBar messageBarType={MessageBarType.info} isMultiline={false}>{result}</MessageBar>;
        }
        const failLog = result.failLog.map( (item, idx) =>
            (<MessageBar key={idx} messageBarType={MessageBarType.error} isMultiline={false}>{item}</MessageBar>));
        return (<div>
            {result.imported > 0 && <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>Zaimportowano {result.imported} transakcji</MessageBar>}
            {result.skipped > 0 && <MessageBar messageBarType={MessageBarType.info} isMultiline={false}>Pominięto {result.skipped} transakcji</MessageBar>}
            {result.failed > 0 &&
                <MessageBar messageBarType={MessageBarType.error} isMultiline={false}>
                    Wystąpił błąd w {result.failed} transakcjach
                </MessageBar>
            }
            {failLog}
        </div>)
    }

    return (
        <AppContent title={'Import transakcji z banku mBank (Zestawienie operacji)'}>
            <form>
                <input type="file" name="file" onChange={(e) => setFile(e.target.files[0])}/>
                <PrimaryButton text='Importuj CSV (Separator ";")' onClick={_submitFile}/>
            </form>
            {messageBar(result)}
            <PaymentList data={payments} update={setPayments} title={'Nieprzypisane wpłaty'}/>
        </AppContent>
    );
}

export default MBankBank;